import "./App.css";
import { Route, Routes } from "react-router-dom";
import PageHome from "./PageHome";
import PageTrack from "./PageTrack";
import { useEffect, useState } from "react";

function App() {
  // Fetch Data
  const [datas, setDatas] = useState([]);
  async function fetchData() {
    const bnToolUrl = process.env.REACT_APP_BN_TOOL_URL;
    const bnToolHeader = new Headers();
    bnToolHeader.append("B-API-KEY", process.env.REACT_APP_B_API_KEY);
    const bnToolOptions = {
      method: "GET",
      headers: bnToolHeader,
      // mode: "no-cors",
      redirect: "follow",
    };

    const resBnTool = await fetch(bnToolUrl, bnToolOptions);

    const resBnToolJson = await resBnTool.json();

    setDatas([...resBnToolJson]);
  }
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<PageHome />} />
        <Route path="/:trackSearch" element={<PageTrack datas={datas} />} />
      </Routes>
    </div>
  );
}

export default App;
